import { render } from "./RoomCard.vue?vue&type=template&id=1a33cdaa&scoped=true"
import script from "./RoomCard.vue?vue&type=script&lang=js"
export * from "./RoomCard.vue?vue&type=script&lang=js"

import "./RoomCard.vue?vue&type=style&index=0&id=1a33cdaa&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3957297443/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a33cdaa"]])

export default __exports__